import { render } from "./PageTitle.vue?vue&type=template&id=77194aa6"
import script from "./PageTitle.vue?vue&type=script&scoped=true&lang=js"
export * from "./PageTitle.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__